import { withRouter, Switch, Route, useLocation } from 'react-router-dom';
import { AccessRoute } from 'routing/AccessRoute';
import { useMobileListCheck } from 'helpers';
import { Welcome } from 'components';
import RPListContainer from './components/RPListContainer';
import ManageRP from './components/ManageRp';
import styles from './resourceParents.module.css';

function ResourceParents(props) {
	const { pathname } = useLocation();
	const {
		basePath = '/resource-parents',
		homesBasePath = '/homes',
		trustedCaseManagerRoute = false,
	} = props;
	const {
		match: {
			params: { rpId },
		},
	} = props;

	useMobileListCheck(pathname === `${basePath}/`);

	return (
		<div className={styles.rpRouteContainer}>
			<RPListContainer
				basePath={basePath}
				homesBasePath={homesBasePath}
				caseManager={trustedCaseManagerRoute}
			/>
			<div className={styles.rpRouteContent}>
				<Switch>
					{trustedCaseManagerRoute ? (
						<Route path={`${basePath}/manage/:rpId?`}>
							<ManageRP
								basePath={basePath}
								homesBasePath={homesBasePath}
								caseManager
							/>
						</Route>
					) : (
						<AccessRoute
							key={`manageRP-${rpId}`}
							path={`${basePath}/manage/:rpId?`}
							authorized={{
								agencyuser: {
									role: ['admin', 'manager', 'social-worker'],
								},
							}}
							fallBackRoute={`${basePath}/`}
							component={ManageRP}
							privileged={true}
						/>
					)}
					<Route path='/' component={Welcome} />
				</Switch>
			</div>
		</div>
	);
}

export default withRouter(ResourceParents);
